export default "__VITE_ASSET__CzFn3Z0i__"